import { render, staticRenderFns } from "./export_matieres.vue?vue&type=template&id=521f11fe"
import script from "./export_matieres.js?vue&type=script&lang=js&external"
export * from "./export_matieres.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports